<app-auth-layout>
      <h2>Introduce tu contraseña</h2>
      <h6>para continuar a Dicea</h6>
      <span class=" mb-3 text-muted small" >nombre de usuario </span>

      <a matTooltip="Editar nombre de usuario" class=" mb-1 text-muted small text-decoration-none mt-3" [routerLink]="['/login']"><mat-icon class="no-ripple-button" style="font-size: 18px;">edit</mat-icon></a>
      <br>
      <form [formGroup]="form">

        <div class="row">
          <div class="col d-flex align-items-center">

          </div>
        </div>
        <br>
        <div class="row">
          <div class="col">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Contraseña</mat-label>
              <input type="password" maxlength="50" matInput placeholder="Ingrese contraseña" formControlName="Clave">
              <mat-error *ngIf="form.controls['Clave'].hasError('required')">El campo es
                <strong>requerido</strong>
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </form>
      <div class="row">
        <div class="col">
          <button mat-raised-button type="submit" [disabled]="!form.valid" color="primary" class="btn-submit w-100">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Continuar
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div>
            <a class=" mb-1 text-muted small text-decoration-none mt-3" [routerLink]="['/login']">¿Has olvidado la contraseña?</a>
            <!-- <a class=" mb-1 text-muted small text-decoration-none mt-3" [routerLink]="['/login']">Usa otra cuenta</a> -->
          </div>
        </div>
      </div>
</app-auth-layout>
